import React, { useState } from "react"
import styled from "styled-components"
import useColor from "@/hooks/useColor"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import SlideImage from "@/components/ParallaxSlider/SlideImage"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import SimpleIconButton from "@/components/common/SimpleIconButton"
import { ICONS } from "@/constants"
import useScrollContext from "@/hooks/useScrollContext"

const Wrapper = styled(GridContainer)`
	--align: left;
	position: relative;
	//aspect-ratio: 375/343;
	min-height: ${getCssSizeValue(367, BREAKPOINTS.MOBILE)};
	background-color: ${({ $bgColor }) => $bgColor || "crimson"};
	padding: ${getCssSizeValue(45, BREAKPOINTS.MOBILE)} ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	padding-bottom: ${getCssSizeValue(47, BREAKPOINTS.MOBILE)};
	row-gap: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
	height: fit-content;
	grid-template-rows: 1fr auto;

	&.flipped {
		grid-template-rows: 1fr;
	}

	.image {
		padding: 0 ${getCssSizeValue(43, BREAKPOINTS.MOBILE)};

		img {
			position: relative !important;
		}
	}

	.title {
		font-weight: 600;
		text-align: var(--align);
	}

	.desc {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.simple-icon-button {
		position: absolute;
		right: 0;
	}
`

const Slide = ({ data, className = "" }) => {
	const id = data?.id || ""
	const title = data?.title || ""
	const description = getHtmlFromRedactorField(data?.description || "")
	const bgColor = useColor(data?.backgroundColor.color)
	const [flip, setFlip] = useState(false)
	const scroll = useScrollContext()
	const handleClick = () => {
		setFlip((prev) => !prev)
		scroll.refresh() //refreshing in case module gets bigger
	}

	return (
		<Wrapper
			id={id}
			className={`${className} ${flip ? "flipped" : ""} slide no-margin padding`}
			$bgColor={bgColor}
			onClick={handleClick}
		>
			{flip ? (
				<Text as="div" className="desc col-mobile-8 typo-borna typo-borna-67" dangerouslySetInnerHTML={description} />
			) : (
				<>
					<SlideImage data={data} className={"col-mobile-8"} fit="contain" />
					<Text className="title uppercase col-mobile-8 typo-borna typo-borna-107">{title}</Text>
				</>
			)}
			<SimpleIconButton
				name={flip ? ICONS.MINUS : ICONS.CROSS}
				borderColor={flip ? "white" : "chilliRed"}
				bgColor={flip ? "white" : "chilliRed"}
				color={flip ? "chilliRed" : "white"}
			/>
		</Wrapper>
	)
}

export default Slide
